export default __webpack_public_path__ + "static/media/Upload-Video-large.cd522164.svg";